export default __webpack_public_path__ + "static/media/speaker3.0a205d2b.jpg";